export function validateEmail(email: string): string | undefined {
    if (!email.trim()) {
        return "Email is required.";
    }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) {
        return "Enter a valid email address.";
    }
    return undefined;
}

/**
 * Mirrors the Cognito password policy in infrastructure/core/cognito.tf.
 *
 * Local dev only, and the last thing in the app that knows what a password
 * looks like: the pool accepts a passkey or an emailed code and nothing else,
 * but cognito-local implements neither, so a seeded local account still signs
 * up and in with one.
 */
export function validatePassword(password: string): string | undefined {
    if (password.length < 8) {
        return "Must be at least 8 characters.";
    }
    if (!/[a-z]/.test(password)) {
        return "Must include a lowercase letter.";
    }
    if (!/[A-Z]/.test(password)) {
        return "Must include an uppercase letter.";
    }
    if (!/[0-9]/.test(password)) {
        return "Must include a number.";
    }
    if (!/[^A-Za-z0-9]/.test(password)) {
        return "Must include a special character.";
    }
    return undefined;
}

export function validateCode(code: string): string | undefined {
    if (!/^(?:\d{6}|\d{8})$/.test(code.trim())) {
        return "Enter the 6- or 8-digit code from your email.";
    }
    return undefined;
}

/**
 * A name to start an account with when the sign-up did not ask for one:
 * "sanne.de-vries@acme.com" is "Sanne De Vries". Cognito requires the
 * attribute, and the person can change it in their profile.
 */
export function nameFromEmail(email: string): string {
    const local = /^[^@+]*/.exec(email.trim())?.[0] ?? "";
    const words = local.split(/[._-]+/).filter((word) => word !== "");

    return (
        words
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ") || email.trim()
    );
}
